import React, {useRef, useState} from "react";
import clsx from "clsx";
import {BackTop} from "antd";

import LandingTitle from "../../components/LandingTitle";
import RealTime from "../../components/LandingInfoBlocks/components/RealTime";
import AlarmAndNotification from "../../components/LandingInfoBlocks/components/AlarmAndNotification";
import DataTrending from "../../components/LandingInfoBlocks/components/DataTrending";

import arrowUp from "../../assets/icons/arrowUp.svg";

import LandingHeader from "../../components/LandingHeader";
import InfoBlock from "../../components/InfoBlock";
import LandingFooterBlock from "../../components/LandingFooterBlock";
import LandingFooter from "../../components/LandingFooter";
import AuthBlock from "../../components/AuthBlock";
import RegistrationAlert from "../../components/Alerts/registration";

import classes from "./LandingPage.module.scss";
import VerificationAlert from "../../components/Alerts/verification";
import LoginAlert from "../../components/Alerts/login";

const backToTopStyle: React.CSSProperties = {
    height: 45,
    width: 45,
    lineHeight: '40px',
    borderRadius: 50,
    backgroundColor: '#A9CC13',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};


export const LandingPage: React.FC = () => {
    const [isRegister, setIsRegister] = useState<boolean>(false);

    const realTimeRef = useRef(null);
    const dataTrendingRef = useRef(null);
    const alarmLogRef = useRef(null);


    return (
        <div>
            <div className={classes.headerBlock}>

                <LandingHeader activationLink={false} onLogin={setIsRegister} isRegister={isRegister}/>

                <div className="container">
                    <LoginAlert/>
                    <RegistrationAlert/>
                    <VerificationAlert/>
                    <div className={clsx("d-flex", classes.auth)}>


                        <div className={clsx("df-col", classes.info)}>
                            <LandingTitle/>
                            <InfoBlock realTimeRef={realTimeRef}
                                       dataTrendingRef={dataTrendingRef}
                                       alarmLogRef={alarmLogRef}
                            />
                        </div>

                        <div>
                            <AuthBlock isRegister={isRegister}
                                       onRegister={setIsRegister}
                            />
                        </div>
                    </div>
                </div>

                <BackTop visibilityHeight={0}>
                    <img src={arrowUp} style={backToTopStyle} alt="arrowUp"/>
                </BackTop>
            </div>

            <div>
                <div className="container">
                    <div className={classes.content}>
                        <RealTime realTimeRef={realTimeRef}/>
                        <AlarmAndNotification alarmLogRef={alarmLogRef}/>
                        <DataTrending dataTrendingRef={dataTrendingRef}/>

                        <LandingFooterBlock/>
                    </div>
                </div>

                <LandingFooter/>

            </div>
        </div>
    );
};
